import src from './app-preview-image.png';
export default { src };